import React, { useState } from 'react';

import { Link } from 'react-router-dom';

import { useQueryPhasePerformanceGetTemplates } from 'api/queries/getTemplateNames.query';

import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import { Button } from 'components/DesignSystem/Button';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import classes from 'components/pages/PhasePerformanceManagePage/components/Manage/Manage.module.scss';
import { SingleTemplateComponent } from 'components/pages/PhasePerformanceManagePage/components/Manage/components/SingleTemplateComponent/SingleTemplateComponent';

export const Manage = () => {
    const [searchValue, setSearchValue] = useState<string>('');
    const [searchWord, setSearchWord] = useState<string>('');

    const { data: allTemplates } = useQueryPhasePerformanceGetTemplates();

    const handleSearchInputChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleOnSearch = () => {
        setSearchWord(searchValue);
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            handleOnSearch();
        }
    };

    const filteredTemplates =
        allTemplates && searchWord.length > 0
            ? allTemplates.templates.filter((item) => {
                  return item.name.toLowerCase().includes(searchWord.toLowerCase());
              })
            : allTemplates?.templates;

    return (
        <>
            <div data-testid={'top-content'} className={classes.topContent}>
                <div className={classes.searchInputContainer}>
                    <TextInput
                        placeholder={'Search Template...'}
                        value={searchValue}
                        onChange={handleSearchInputChange}
                        onClear={(e) => {
                            e.stopPropagation();
                            setSearchValue('');
                            setSearchWord('');
                        }}
                        onKeyDown={onKeyDown}
                        searchable={true}
                        onSearch={handleOnSearch}
                        id={'manage_phase_template_search_input'}
                    />
                </div>
                <Button
                    component={Link}
                    to={`${portfolioConfig.phasePerformanceManage.link}/${portfolioConfig.phasePerformanceManageAddTemplate.link}`}
                    size={'large'}
                    variant={'primary'}
                    id={'manage_phase_template_add_button'}
                >
                    Add Phase Template
                </Button>
            </div>
            <div className={classes.templatesSection}>
                {filteredTemplates?.map((item, index) => (
                    <SingleTemplateComponent key={item.id} template={item} isOpenInitial={index === 0} />
                ))}
            </div>
        </>
    );
};
